import { useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'

import _ from 'lodash'

import { useLazyQuery } from '@apollo/client'

import { StrapiQuery } from '~/utils/strapi'

import { BLOG_PAGE_SIZE, RecentArticlesQuery } from '~/pages/weekly'

import BlogPostCard from '../BlogPostCard'
import SkeletonBlogPostCard from '../SkeletonBlogPostCard'

import { SectionContainer, SectionContent, SectionGrid, SectionTitle, SectionTitleDivider } from './BlogSectionShards'
import { BlogSectionProps } from './BlogSectionTypes'
import { extractBlogArticles } from './BlogSectionUtils'

const BlogSectionView = ({ title, divider, initialArticles, featuredArticlesIds }: BlogSectionProps) => {
  const [allArticles, setAllArticles] = useState(initialArticles)
  const [hasMore, setHasMore] = useState(true)
  const [fetchMore, { loading }] = useLazyQuery(StrapiQuery)
  const offset = allArticles?.length ?? 0

  const handleScroll = async () => {
    const newArticles = await fetchMore({
      variables: {
        query: RecentArticlesQuery({
          excludedIds: featuredArticlesIds,
          excludedCategories: [],
          offset,
          limit: BLOG_PAGE_SIZE,
        }),
      },
    }).then(data => extractBlogArticles(data))

    if (newArticles.length <= BLOG_PAGE_SIZE) {
      setAllArticles([...allArticles, ...newArticles])
      newArticles.length < BLOG_PAGE_SIZE && setHasMore(false)
    }
  }

  const handleScrollDebounced = _.debounce(handleScroll, 600)

  useEffect(() => {
    hasMore && handleScrollDebounced()
  }, [offset, hasMore])

  return (
    <SectionContainer>
      <SectionTitleDivider divider={divider}>
        <SectionTitle>{title}</SectionTitle>
      </SectionTitleDivider>
      <SectionContent>
        <InfiniteScroll
          hasChildren={true}
          scrollThreshold={0.7}
          next={handleScrollDebounced}
          hasMore={hasMore}
          dataLength={offset}
          loader=''>
          <SectionGrid>
            {allArticles?.map((item, i) => <BlogPostCard key={i} post={item} />)}
            {hasMore && loading && <SkeletonBlogPostCard />}
          </SectionGrid>
        </InfiniteScroll>
      </SectionContent>
    </SectionContainer>
  )
}

export default BlogSectionView
